import React from 'react'
import PropTypes from 'prop-types'
import { MaxWidthContainerV2 } from 'Layout'
import WithWindowSize from 'Components/WithWindowSize'
import WithSpinner from 'Components/WithSpinner'
import Population from './components/Population'
import Composition from './components/Composition'
import ExtraStats from './components/ExtraStats'
// import ChildrenPerHousehold from './components/ChildrenPerHousehold'
import NearbyMapIntro from './components/NearbyMapIntro'

import {
  _Demographics, _ModalContainer, _CoreComponentsTitle,
} from './styles.js'


const Demographics = ({
  listing, building, winWidth, fromPhotosAndLocationModal, school, data, key, places,
  isLoading = false, modalView, googleAnalyticsEvent, handleDemographicMapClick = () => { }, source,
}) => {
  const desktopView = winWidth > 768
  const xsView = winWidth <= 414
  const lowestArea = (listing && listing.lowest_area)
    || (building && building.lowest_area)
    || (school && school.primary_address.breadcrumb[0])
  const address = listing?.address || building?.addresses[0] || school?.primary_address

  if(!isLoading && !data) return ''
  const areaName = lowestArea ? lowestArea.display_name : ''
  const coreComponents = (
    <WithSpinner showSpinner={isLoading}>
      <_CoreComponentsTitle>{`${lowestArea ? lowestArea.display_name : ''} Demographics`}</_CoreComponentsTitle>
      <Population desktopView={desktopView} data={data} xsView={xsView} />
      <Composition data={data} />
      {/* <ChildrenPerHousehold desktopView={desktopView} data={data} xsView={xsView} /> */}
      <ExtraStats
        data={data}
        googleAnalyticsEvent={googleAnalyticsEvent}
        source={source}
        areaName={areaName}
      />
    </WithSpinner>
  )
  if(!modalView) {
    return (
      <_Demographics
        key={key || address?.id}
      >
        {
          listing || building || school ?
            <NearbyMapIntro
              listing={listing}
              building={building}
              schools={school}
              desktopView={desktopView}
              handleDemographicMapClick={handleDemographicMapClick}
              places={places}
              googleAnalyticsEvent={googleAnalyticsEvent}
              nearbyStops={places?.transit?.data?.hits}
            />
            : ''
        }
        {coreComponents}
      </_Demographics>
    )
  }

  return (
    <_ModalContainer>
      <MaxWidthContainerV2>
        <h3>{`${lowestArea ? lowestArea.display_name : ''} Demographics`}</h3>
        {
          !fromPhotosAndLocationModal && (listing || building) ?
            <NearbyMapIntro
              listing={listing}
              building={building}
              schools={school}
              handleDemographicMapClick={handleDemographicMapClick}
              address={school}
              places={places}
              nearbyStops={places?.transit?.data?.hits}
              googleAnalyticsEvent={googleAnalyticsEvent}
            />
            : ''
        }
        {coreComponents}
      </MaxWidthContainerV2>
    </_ModalContainer>
  )
}


Demographics.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    lowest_area: PropTypes.shape({}),
    address: PropTypes.string,
  }),
  building: PropTypes.shape({
    lowest_area: PropTypes.shape({}),
    address: PropTypes.string,
    addresses: PropTypes.string,
  }),
  places: PropTypes.shape({
    grocery: PropTypes.shape({ data: PropTypes.shape({}) }),
    restaurant: PropTypes.shape({ data: PropTypes.shape({}) }),
    schools: PropTypes.shape({ data: PropTypes.shape({
      hits: PropTypes.arrayOf(PropTypes.shape({})),
    }) }),
    transit: PropTypes.shape({ data: PropTypes.shape({
      hits: PropTypes.arrayOf(PropTypes.shape({})),
    }) }),
  }),
  winWidth: PropTypes.number,
  isLoading: PropTypes.bool,
  data: PropTypes.shape({}),
  modalView: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  handleDemographicMapClick: PropTypes.func,
  fromPhotosAndLocationModal: PropTypes.bool,
  school: PropTypes.shape({
    primary_address: PropTypes.shape({
      breadcrumb: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
  source: PropTypes.string,
  key: PropTypes.string,
  transitData: PropTypes.shape({
    data: PropTypes.shape({}),
  }),
}

export default WithWindowSize(Demographics)
